import { Anexo } from "../../../../interfaces/entities/Reembolso/Anexo";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { downloadBase64File } from "../../../../utils/DownloadFile";
import "./styles.css";

const AttachmentsCard: React.FC<{ anexos: Array<Anexo> }> = ({ anexos }) => {

  const accessibility = useAccessibility();

  const applyRadiusBottom = (indexAnexo: number) => { //Aplica estilo radius-bottom para o último anexo da lista, fechando o contorno do card
    return indexAnexo + 1 === anexos.length ? 'radius-bottom' : '';
  }

  const handleDownload = (anexo: Anexo) => {
    console.log(anexos)
    downloadBase64File(anexo.arquivo, anexo.nomeArquivo)
  }

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-title">Complementos</span>
        </div>
        {anexos.map((anexo, index) => (
          <div key={index}
            className={`${index % 2 === 0 ? `registration-data-row registration-data-row-secondary` : `registration-data-row`} ${applyRadiusBottom(index)}`}
            style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}
          >
            <span style={accessibility.textStyleAccessibility} className="registration-data-key">Anexo {index + 1}</span>
            <button style={accessibility.textStyleAccessibility} className="registration-data-value registration-data-value-button" onClick={() => {handleDownload(anexo)}} aria-label={`Ver anexo do reembolso ${anexo.nomeArquivo}`}>{anexo.nomeArquivo}</button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default AttachmentsCard;